import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { EmailValidator } from '../../../../../../../ui/gzForm/validators/email.validator';

export const EXTENSION_VALIDATION_REGEX = '^\\.?[^\\\\\\/:*?"<>| ]+$';

// validate path win
export function validatePathWin(value: string): ValidationResult {
  // define standard paths
  const standardPaths = [
    '%ALLUSERSPROFILE%',
    '%AppData%',
    '%HOMEPATH%',
    '%LOCALAPPDATA%',
    '%ProgramFiles%',
    '%USERPROFILE%',
    '%CommonProgramFiles%',
    '%COMMONPROGRAMFILES(X86)%',
    '%WinDir%',
    '%WINDIR%\\system32',
    '%PROGRAMFILES(X86)%',
    '%TEMP%',
    '%SystemDrive%',
  ];

  // check if value is a standard path
  if (standardPaths.includes(value)) {
    return { valid: true };
  }

  // check if the path is composed from a standard path and any other folder
  standardPaths.forEach(path => {
    // split by the standard path
    const splitPath = value.split(path);

    if (splitPath.length > 1) {
      // try to create a windows path without the standard path and validate it now
      value = 'x:' + splitPath[1];
    }
  });

  if (
    !value.match(
      /^((\\\\[a-zA-Z0-9-]+\\[a-zA-Z0-9`~!@#$%^&(){}'._-]+([ ]+[a-zA-Z0-9`~!@#$%^&(){}'._-]+)*)|([a-zA-Z]:))(\\[^ \\/:*?""<>|]+([ ]+[^ \\/:*?""<>|]+)*)*\\?$/
    )
  ) {
    return {
      valid: false,
      error: translateFn('Invalid path'),
    };
  }

  return { valid: true };
}

// validate multiple emails
export async function validateMultipleEmails(value: string): Promise<ValidationResult> {
  const emails = value.split(', ');
  let isValid = true;

  // stop if at least one email is invalid
  for (const email of emails) {
    isValid = (await EmailValidator('')(email)).valid;

    if (!isValid) {
      return {
        valid: false,
        error: translateFn('At least one email address is invalid.'),
      };
    }
  }

  return { valid: true };
}

// validate header name
export function validateHeaderName(value: string): ValidationResult {
  let isValid = true;

  // each char
  for (let charIndex = 0; charIndex < value.length; charIndex++) {
    // get int value for character
    const charCode = value.charCodeAt(charIndex);

    // test against RFC
    if (charCode < 33 || charCode > 126 || charCode === 58) {
      isValid = false;
      break;
    }
  }

  if (!isValid) {
    return {
      valid: false,
      error: translateFn('Invalid character in header name'),
    };
  }

  return { valid: true };
}

// validate email pattern (See emailPatternMultiple from ExtJs)
export async function validateEmailPattern(value: string): Promise<ValidationResult> {
  // must have at least 3 characters
  if (value.length < 3) {
    return {
      valid: false,
      error: translateFn(
        'Invalid email or domain pattern. A domain must include ? or * and be at least 3 characters long.'
      ),
    };
  }

  // pattern
  if (value.indexOf('*') > -1 || value.indexOf('?') > -1) {
    return {
      valid: true,
    };
  }

  // validate email if no pattern
  return await EmailValidator(translateFn('Invalid email or domain pattern. A domain must include ? or *.'))(value);
}
